<template>
  <div class="py-3 h-100">
    <div class="d-flex justify-content-between align-items-center">
      <p class="my-4">Gallery</p>
      <div>
        <button class="btn btn-primary" @click="addMedia()">
          <i class="fa-solid fa-plus-circle me-2" />
          Add Media
        </button>

        <button
          class="btn btn-success ms-2"
          @click="saveMedia()"
          v-if="fileInputs.length"
        >
          <i class="fa-solid fa-file-upload me-2" />
          Save media
        </button>
      </div>
    </div>

    <div
      class="image-grid cursor-pointer position-relative"
      v-for="media in medias"
      :key="`media-${media.id}`"
      @click="openMediaPreview(media)"
    >
      <template v-if="media.mime && media.mime.includes('video')">
        <i
          class="fas fa-video-camera position-absolute text-light bg-dark p-2 rounded small"
          style="z-index: 2"
        />
        <video :src="Helper.formatMediaUrl(media)"></video>
      </template>
      <img :src="Helper.formatMediaUrl(media)" v-else />
    </div>

    <div
      class="image-grid cursor-pointer position-relative"
      v-for="media in fileInputs"
      :key="`preview-${media.id}`"
      @click="openMediaPreview(media, 'preview')"
    >
      <template v-if="media.file && media.file.type.includes('video')">
        <i
          class="fas fa-video-camera position-absolute text-light bg-dark p-2 rounded small"
          style="z-index: 2"
        />
        <video :src="media.preview"></video>
      </template>
      <img :src="media.preview" v-else />
      <button
        class="btn btn-sm btn-danger position-absolute"
        style="z-index: 2; top: 0; right: 0"
        @click.stop="deleteFileInput(media.id)"
      >
        <i class="fas fa-trash-alt" />
      </button>
    </div>

    <div class="image-grid image-grid-placeholder">
      <button class="btn h-100 w-100 fw-bold lh-sm" @click="addMedia()">
        <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
        Add Media
      </button>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  props: ["pavementId", "pavementData"],
  data() {
    return {
      medias: [],
      fileInputs: [],
    };
  },
  methods: {
    deleteFileInput(mediaId) {
      this.fileInputs = this.fileInputs.filter((input) => input.id != mediaId);
    },
    openMediaPreview(media, type) {
      this.$emit(
        "open-media-preview",
        type == "preview" ? media.preview : this.Helper.formatMediaUrl(media),
        media.file?.type || media.mime
      );
    },
    imageChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        if (file.type.includes("video")) {
          this.fileInputs.push({
            id: Date.now() + 13,
            file: file,
            preview: URL.createObjectURL(file),
          });
        } else {
          const reader = new FileReader();

          reader.readAsDataURL(file);

          reader.onload = (readerEvent) => {
            this.fileInputs.push({
              id: Date.now() + 13,
              file: file,
              preview: readerEvent.target.result,
            });
          };
        }
      });

      this.Helper.successToast(
        `${files.length} media file${files.length > 1 ? "s" : ""} added`
      );
    },
    addMedia() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = true;

      input.accept = "image/*,video/*";

      input.onchange = this.imageChanged;

      input.click();
    },
    async saveMedia() {
      await Swal.fire({
        title: "<h5 class='fw-bold'>Save media to gallery?</h5>",
        showCancelButton: true,
        icon: "question",
        iconColor: "green",
        reverseButtons: true,
        confirmButtonText: "Save",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          try {
            await this.uploadFileInput();

            this.Helper.toggleLoadingSpinner(false);

            this.triggerAlert("success", "Files uploaded");
          } catch (error) {
            this.Helper.toggleLoadingSpinner(false);

            this.triggerAlert("error", error);
          }
        }
      });
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        try {
          const formData = new FormData();

          formData.append("ref", "pavement-case");
          formData.append("refId", this.pavementData.id);
          formData.append("field", "gallery");

          this.fileInputs.forEach((input) => {
            formData.append("files", input.file, input.file.name);
          });

          const [call, error] = await this.Helper.handlePromise(
            this.API.postForm("upload", formData)
          );

          if (error) {
            return reject(error);
          } else {
            this.fileInputs = [];

            call.data.forEach((data) => {
              this.medias.push(data);
            });

            return resolve("OK");
          }
        } catch (error) {
          return reject(error);
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
  },
  async mounted() {
    if (this.pavementData) {
      this.medias = this.medias
        .concat(
          this.pavementData.gallery,
          this.pavementData.media,
          this.pavementData.media_during,
          this.pavementData.media_after,
          this.pavementData.pavement_works.map((work) =>
            work.img_before.concat(work.img_during, work.img_after)
          )
        )
        ?.flat()
        .sort((a, b) => {
          return (
            this.Helper.moment(a.createdAt).valueOf() -
            this.Helper.moment(b.createdAt).valueOf()
          );
        });
    }
  },
  beforeDestroy() {
    this.fileInputs.forEach((media) => {
      if (media.file?.type.includes("video")) {
        URL.revokeObjectURL(media.preview);
      }
    });
  },
};
</script>